import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function MenuIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M3.75 12h16.5M3.75 6h16.5M3.75 18h16.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
}
